import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import DashedLabel from '../atoms/DashedLabel';
// @ts-expect-error import not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error import not typed
import { getHistoryFormattedTimestamp } from 'conversations-message-history/util/getHistoryFormattedTimestamp';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallStatusMessage = ({
  message
}) => {
  const timestamp = getTimestamp(message);
  const historyFormattedTimestamp = getHistoryFormattedTimestamp(timestamp) || '';
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    "data-test-id": 'call-status-message',
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.callStatus.inboundCallReceived',
      options: {
        historyFormattedTimestamp
      },
      "data-test-id": 'inbound-call-received-message'
    })
  });
};
CallStatusMessage.displayName = 'CallStatusMessage';
export default CallStatusMessage;